import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Headroom from 'headroom.js';
import {
  headerHeight,
  announcementBarHeight,
  updateHeaderHeightVars,
  throttle,
} from '../helpers';
import { openMinicart } from './minicart';
import { atQuery } from '../components/mediaQueries';
import { showBackdrop, hideBackdrop } from '../components/backdrop';

if (!window.dAgency) window.dAgency = {};

$(function () {
  const $siteHeader = $('.site-header');
  const $header = $siteHeader.find('.header__container');
  const $header_ovrlay = $siteHeader.find('.header__container__overlay');
  if ($siteHeader <= 0 || $header.length <= 0) return false;

  $('html').css('scroll-padding-top', headerHeight() + 'px');
  $('#PageContainer').css(
    'min-height',
    'calc(100vh - ' + headerHeight() + 'px)',
  );
  $('#CartPopup').css('top', headerHeight() + 'px');

  updateHeaderHeightVars(); // onload
  window.addEventListener('resize', throttle(updateHeaderHeightVars, 100)); // onresize

  $(window).on('resize', function () {
    $('html').css('scroll-padding-top', headerHeight() + 'px');
    $('#PageContainer').css(
      'min-height',
      'calc(100vh - ' + headerHeight() + 'px)',
    );
    $('#CartPopup').css('top', headerHeight() + 'px');
  });

  /* ====================== HeadrooomJS ====================== */
  const header = document.querySelector('header.site-header');
  const headerContainer = document.getElementById('header');

  /* ======================== Header ======================== */
  if ($header.hasClass('header__transparent')) {
    if ($(window).scrollTop() === 0) {
      $header.addClass('apply-transparency');
    } else {
      $header.removeClass('apply-transparency');
    }

    $(window).on('scroll', function () {
      if (!$header.hasClass('force-opacity')) {
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        } else {
          $header.removeClass('apply-transparency');
        }
      }
    });
  }

  $header.on('mouseenter', function () {
    if ($(window).outerWidth() > 1024) {
      $header.removeClass('apply-transparency');
    }
  });
  $header.on('mouseleave', function () {
    if (
      $(window).scrollTop() === 0 &&
      $(window).outerWidth() > 1024 &&
      !$header.hasClass('force-opacity')
    ) {
      $header.addClass('apply-transparency');
    }
  });

  $header.find('.header__left__newsletter-button').on('click', function () {
    if (typeof window.dAgency.showNewsletterPopUp === 'function')
      window.dAgency.showNewsletterPopUp();
  });

  const $cartLink = $header.find('.cart-link');
  if ($cartLink.length) {
    $cartLink.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openMinicart();
    });
  }

  /* ======================== Mobile Menu ======================== */
  const $mobileMenu = $header.find('.header__mobile-menu');
  if ($mobileMenu.length > 0) {
    $mobileMenu.css('top', 0);
    $mobileMenu.css('height', '100dvh');

    if ($mobileMenu.hasClass('header__mobile-menu--drawer')) {
      const $firstLevel = $mobileMenu.find(
        '.header__mobile-menu--drawer__first-level__title',
      );
      $firstLevel.each(function () {
        const submenu = $(this).data('submenu');
        const $connectedSecondLevel = $mobileMenu.find(
          '.header__mobile-menu--drawer__second-level[data-submenu="' +
            submenu +
            '"]',
        );
        $(this).on('click', function (e) {
          if (
            e.target.getAttribute('href') ||
            $connectedSecondLevel.find(
              '.header__mobile-menu--drawer__second-level__title',
            ).length <= 0
          )
            return;

          $connectedSecondLevel.addClass('open');
        });
      });

      const $secondLevel = $mobileMenu.find(
        '.header__mobile-menu--drawer__second-level',
      );
      $secondLevel.each(function () {
        const $level = $(this);
        const $close = $(this).find(
          '.header__mobile-menu--drawer__second-level__close',
        );
        $close.on('click', function () {
          $level.removeClass('open');
        });

        const $titles = $(this).find(
          '.header__mobile-menu--drawer__second-level__title',
        );
        $titles.each(function () {
          const accordionIndex = $(this).data('accordion-index');
          const $otherThirdLevels = $level.find(
            '.header__mobile-menu--drawer__third-level:not([data-accordion-index="' +
              accordionIndex +
              '"])',
          );
          const $connectedThirdLevel = $level.find(
            '.header__mobile-menu--drawer__third-level[data-accordion-index="' +
              accordionIndex +
              '"]',
          );
        });
      });
    }

    var isMenuOpen = false;
    $header.find('.header__burger-icon').on('click', function () {
      isMenuOpen = !isMenuOpen;
      $mobileMenu.toggleClass('open');
      if (isMenuOpen) {
        $('html').css('overflow-y', 'hidden');
        $header.removeClass('apply-transparency');
        $header.addClass('force-opacity');
        atQuery('min', 'md', () => {
          $header_ovrlay.addClass('active');
        });
      } else {
        $('html').css('overflow-y', '');
        $header.removeClass('force-opacity');
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        }
        $header_ovrlay.removeClass('active');
      }
    });

    $header_ovrlay.on('click', function () {
      $header.find('.header__burger-icon').trigger('click');
      $header_ovrlay.removeClass('active');
    });

    const $mobileMenuClose = $('.header__mobile-menu--drawer__close');
    $($mobileMenuClose).on('click', function () {
      $header.find('.header__burger-icon').trigger('click');
    });

    const $mobileMenuImages = $('.header__mobile-menu__level__image');
    if ($mobileMenuImages.length > 0) {
      $mobileMenuImages.each(function () {
        const $links = $(this).prev();
        $links.css(
          'height',
          'calc(100% - ' + $(this).innerHeight() + 'px - 1rem)',
        );
      });
    }

    $('[data-mobile-menu-opener]').on('click', function (e) {
      if (!e.target.getAttribute('href')) {
        const menuName = $(this).data('mobile-menu-opener');
        $('[data-mobile-menu="' + menuName + '"]').css(
          'transform',
          'translate3d(0, 0, 0)',
        );
      }
    });

    $('[data-mobile-menu] .header__mobile-menu__level__title').on(
      'click',
      function () {
        const $menu = $(this).closest('.header__mobile-menu__level');
        $menu.css('transform', '');
      },
    );
  }

  /* ======================== Desktop Menu ======================== */
  const $desktopMenu = $header.find('.header__desktop-menu');
  const $header_announcement_container = $('#header-announcement-container');
  const $announcement_bar = $('#shopify-section-announcement-bar');
  if ($desktopMenu.length > 0) {
    if ($desktopMenu.hasClass('header__desktop-menu--drawer')) {
      const $firstLevelLinks = $desktopMenu.find(
        '.header__desktop-menu--drawer__inline-elements__link',
      );

      $firstLevelLinks.each(function () {
        $(this).on('click', function (e) {
          if ($(window).outerWidth() <= 1280) return;
          if (!$(e.target).hasClass('first-level')) return;

          if ($(this).hasClass('open')) {
            $header.removeClass('force-opacity');
            $(this).removeClass('open');
            $(this).find('.open').removeClass('open');
            $('html').css('overflow-y', '');

            hideBackdrop();
            setTimeout(function () {
              $header_announcement_container.css('z-index', '');
              if ($announcement_bar.length > 0) {
                $announcement_bar.css('z-index', '');
              }
            }, 250);
          } else {
            $desktopMenu
              .find('.header__desktop-menu--drawer__second-level')
              .each(function () {
                if (
                  $('body').hasClass('template-blog') ||
                  $('body').hasClass('template-collection')
                ) {
                  if (window.scrollY > announcementBarHeight()) {
                    $(this).css(
                      'height',
                      'calc(100vh - ' +
                        headerHeight() +
                        'px + ' +
                        (window.scrollY - announcementBarHeight()) +
                        'px)',
                    );
                  } else {
                    $(this).css(
                      'height',
                      'calc(100vh - ' +
                        headerHeight() +
                        'px + ' +
                        window.scrollY +
                        'px)',
                    );
                  }
                } else {
                  $(this).css(
                    'height',
                    'calc(100vh - ' + headerHeight() + 'px)',
                  );
                }
              });

            $header.addClass('force-opacity');
            $(this).addClass('open');
            $('html').css('overflow-y', 'hidden');

            showBackdrop();
            $header_announcement_container.css('z-index', '20');
            if ($announcement_bar.length > 0) {
              $announcement_bar.css('z-index', '20');
            }
          }
        });
      });
    }
  }

  const $desktopMenuClose = $('.header__desktop-menu--drawer__close');
  $($desktopMenuClose).on('click', function () {
    $desktopMenu
      .find('.header__desktop-menu--drawer__inline-elements__link')
      .removeClass('open');
    $('html').css('overflow-y', '');
    hideBackdrop();
    setTimeout(function () {
      $header_announcement_container.css('z-index', '');
      if ($announcement_bar.length > 0) {
        $announcement_bar.css('z-index', '0');
      }
    }, 250);
  });

  /* ==================== Desktop Search PopUp ==================== */
  const $deskSearchBar = $header.find('.header__search-popup');
  if ($deskSearchBar.length > 0) {
    $deskSearchBar.css('top', headerHeight() + 'px');

    const $iconSearch = $header.find('.header__right__element.search');
    if ($iconSearch.length > 0) {
      $iconSearch.on('click', function (e) {
        e.preventDefault();
        $deskSearchBar.css('top', headerHeight() + 'px');
        $deskSearchBar.toggleClass('open');

        if ($deskSearchBar.hasClass('open')) {
          $header.removeClass('apply-transparency');
          $header.addClass('force-opacity');
          $deskSearchBar.find('form input[type="text"]').trigger('focus');
          $header_announcement_container.css('z-index', '20');
          if ($announcement_bar.length > 0) {
            $announcement_bar.css('z-index', '20');
          }
          showBackdrop();
        } else {
          $header.removeClass('force-opacity');
          if ($(window).scrollTop() === 0) {
            $header.addClass('apply-transparency');
          }
          hideBackdrop();
          setTimeout(function () {
            $header_announcement_container.css('z-index', '');
            if ($announcement_bar.length > 0) {
              $announcement_bar.css('z-index', '');
            }
          }, 100);
        }
      });
    }

    $(window).on('resize', function () {
      if ($(window).outerWidth() <= 1024) {
        $header.removeClass('force-opacity');

        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        } else {
          $header.removeClass('apply-transparency');
        }
      } else {
        $deskSearchBar.css('top', headerHeight() + 'px');
      }
    });

    const $closeIcon = $deskSearchBar.find('.header__search-popup__close-icon');
    if ($closeIcon.length > 0) {
      $closeIcon.on('click', function () {
        $deskSearchBar.removeClass('open');
        $header.removeClass('force-opacity');
        if ($(window).scrollTop() === 0) {
          $header.addClass('apply-transparency');
        }
        hideBackdrop();
      });
    }
  }
});
